import e,{keyframes as o}from"../../node_modules/styled-components/dist/styled-components.esm.js";const t=o`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`,s=e.svg`
  position: absolute;
  z-index: 2;
  animation: 0.8s ${t} infinite linear;
`;export{s as Svg};
